import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 16px;
  line-height: 24px;
  padding-left: 16px;
  font-weight: 300;

  a {
    display: flex;
    width: 100%;
    color: #697684;
    &:hover,
    &:active {
      color: #2b6ed2;
    }
  }
`;
